export const SIGNUP_FORM_CLASSNAME = "signup-form";

export const SIGNUP_FORM_STACK_CLASSNAME = "flex flex-col gap-[var(--signup-field-stack)]";

export const SIGNUP_FORM_ROW_CLASSNAME =
  "grid grid-cols-1 gap-[var(--signup-field-row-gap)] sm:grid-cols-2";

export const SIGNUP_STEP_ACTIONS_ROW_CLASSNAME =
  "mt-6 grid grid-cols-[minmax(0,1fr)_minmax(0,4fr)] gap-3";

export const SIGNUP_STEP_BACK_BUTTON_CLASSNAME = "w-full min-w-0";

export const SIGNUP_STEP_CONTINUE_BUTTON_CLASSNAME = "w-full min-w-0";

/**
 * Tertiary text-only action ("Skip", "This isn't my practice"): same 48px
 * footprint and padding as the marketing CTAs, no background or stroke,
 * text darkens on hover.
 */
export const SIGNUP_STEP_GHOST_BUTTON_CLASSNAME =
  "text-muted-foreground hover:text-foreground type-body-sm min-h-12 w-full px-10 py-4 text-center transition-colors";

/**
 * Rendered height of the signup text inputs: type-body-md line-height (24px)
 * + py-3 (24px) + 1px top/bottom borders = 50px. The country pickers (phone
 * code + address country) hold shorter content (caption text, flag, chevron),
 * so they pin this min-height to stay flush with their row-mates.
 */
const SIGNUP_FIELD_CONTROL_MIN_HEIGHT_CLASSNAME = "min-h-[50px]";

export const SIGNUP_FIELD_INPUT_CLASSNAME =
  "type-body-md h-auto rounded-[2px] border border-mocha/20 bg-white px-[14px] py-3 text-mocha placeholder:text-mocha/32 focus-visible:border-gold focus-visible:ring-[3px] focus-visible:ring-gold/30 focus-visible:outline-none disabled:opacity-50";

export const SIGNUP_FIELD_COUNTRY_BUTTON_CLASSNAME = `type-body-sm flex h-auto ${SIGNUP_FIELD_CONTROL_MIN_HEIGHT_CLASSNAME} items-center gap-2 rounded-[2px] border border-mocha/20 bg-white px-3 py-3 text-mocha focus-visible:border-gold focus-visible:ring-[3px] focus-visible:ring-gold/30 focus-visible:outline-none`;

export const SIGNUP_FIELD_COUNTRY_MENU_CLASSNAME =
  "absolute top-full left-0 z-20 mt-1 max-h-48 w-32 overflow-y-auto rounded-[2px] border border-mocha/20 bg-white shadow-lg";

export const SIGNUP_FIELD_LABEL_CLASSNAME = "text-mocha/65";

export const SIGNUP_PLACES_DROPDOWN_CLASSNAME =
  "relative z-50 mt-1 max-h-[min(18rem,50vh)] w-full overflow-y-auto rounded-[2px] border border-mocha/20 bg-white shadow-lg sm:absolute";
